module.exports = __webpack_public_path__ + "static/media/css_logo.0fc9d143.png";